import React from 'react';

export default function SecurityShield() {
  return (
    <svg width="205" height="205" viewBox="0 0 205 205">
      <g className="fill-marvel">
        <path d="M117.448 61.876c0-8.256-6.692-14.948-14.948-14.948s-14.948 6.692-14.948 14.948v12.813c0 1.179.956 2.135 2.135 2.135h25.625c1.179 0 2.135-.956 2.135-2.135v-12.813zM205 16.682c-.056-9.195-7.521-16.621-16.716-16.631h-171.551c-9.203.052-16.635 7.53-16.631 16.733l-.102 62.704c.462 60.269 42.483 112.234 101.321 125.298.546.109 1.101.164 1.657.162.574-.002 1.146-.062 1.708-.179 58.72-13.582 100.281-65.916 100.211-126.186l.102-61.901zm-140.938 115.663v-46.979c0-4.717 3.824-8.542 8.542-8.542h2.135v-14.948c0-15.332 12.429-27.76 27.76-27.76 15.332 0 27.76 12.429 27.76 27.76v14.948h2.135c4.717 0 8.542 3.824 8.542 8.542v46.979c0 2.265-.9 4.438-2.502 6.04-1.602 1.602-3.774 2.502-6.04 2.502h-59.792c-4.717 0-8.542-3.824-8.542-8.542z" />
        <circle cx="102.5" cy="113.126" r="10.677" />
      </g>
    </svg>
  );
}



// WEBPACK FOOTER //
// ./src/components/icons/SecurityShield/index.js